import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IMedicalTestDetails, IMedicalTestFilesDetailsDTO } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { Response } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class MedicalTestRequestService {
  getAvailableLabsAndPricesUrl: string =
    'api/AdminCenterTests/GetAvailableLabsAndPrices';
  getTestsUrl: string = 'api/Tests/GetTests';
  validateLabPromoCodeUrl: string = 'api/AdminCoupons/ValidateLabPromoCode';
  addTestRequestUrl: string = 'api/AdminEhrTestRequests/V2/AddTestRequest';
  getTestRequestDetailsUrl: string =
    'api/AdminTestRequests/GetTestRequestDetails';
  downloadTestRequestResultsUrl: string =
    'api/AdminTestRequests/DownloadTestRequestResults';
  uploadResultUrl: string = 'api/AdminTestReservations/UploadTestResult';
  getPatientTestRequestsUrl: string =
    'api/AdminTestRequests/GetPatientTestRequests';
  deleteTestResultUrl: string = 'api/AdminTestReservations/DeleteTestResult';
  getPatientRecentMedicalTestsUrl: string = 'api/AdminEhrMedicalTests/GetAllPatientRecentMedicalTests';
  getPatientCompletedMedicalTestsUrl: string = 'api/AdminEhrMedicalTests/GetAllPatientCompletedMedicalTests';
  getMedicalTestDetailsUrl: string = 'api/AdminEhrTestRequests/GetTestRequestDetails';
  getMedicalTestFileDetailsUrl: string = 'api/AdminEhrTestResultsFiles/GetMedicalTestResultFilesByAdminByEhrTransactionId'

  constructor(private http: HttpClient) {}

  getMedicalTests(): Observable<any> {
    return this.http.get(this.getTestsUrl);
  }

  getLabs(paramsObject): Observable<any> {
    let params = new HttpParams()
      .set('areaId', paramsObject.areaId)
      .set('cityId', paramsObject.cityId)
      .set('testIds', paramsObject.testIds)
      .set('isVisitHome', paramsObject.isVisitHome)
      .set('patientId', paramsObject.patientId);

    return this.http.get(this.getAvailableLabsAndPricesUrl, {
      params: params,
    });
  }

  validateLabPromoCode(isHomeTest, paramsObject): Observable<any> {
    let params;

    if (isHomeTest) {
      params = new HttpParams()
        .set('testIds', paramsObject.testIds)
        .set('couponNameOrCode', paramsObject.couponNameOrCode)
        .set('centerId', paramsObject.centerId)
        .set('areaId', paramsObject.areaId)
        .set('testVisitTypeId', paramsObject.testVisitTypeId);
    } else {
      params = new HttpParams()
        .set('testIds', paramsObject.testIds)
        .set('couponNameOrCode', paramsObject.couponNameOrCode)
        .set('branchId', paramsObject.branchId)
        .set('centerId', paramsObject.centerId)
        .set('areaId', paramsObject.areaId)
        .set('testVisitTypeId', paramsObject.testVisitTypeId);
    }

    return this.http.get(this.validateLabPromoCodeUrl, {
      params: params,
    });
  }

  addTestRequest(bodyObject): Observable<any> {
    return this.http.post(this.addTestRequestUrl, bodyObject);
  }

  getPatientTestRequests(patientId): Observable<any> {
    let params = new HttpParams().set('patientId', patientId);

    return this.http.get(this.getPatientTestRequestsUrl, {
      params: params,
    });
  }

  getPatientRecentMedicalTests(patientId, currentPage, pageSize): Observable<any> {
    let params = new HttpParams().set('patientId', patientId)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize);

    return this.http.get(this.getPatientRecentMedicalTestsUrl, {
      params: params,
    });
  }

  getPatientCompletedMedicalTests(patientId, currentPage, pageSize): Observable<any> {
    let params = new HttpParams().set('patientId', patientId)
      .set('currentPage', currentPage)
      .set('pageSize', pageSize);

    return this.http.get(this.getPatientCompletedMedicalTestsUrl, {
      params: params,
    });
  }

  getMedicalTestDetails(medicalTestId): Observable<Response<IMedicalTestDetails>>{
    return this.http.get<Response<IMedicalTestDetails>>(`${this.getMedicalTestDetailsUrl}/${medicalTestId}`);
  }

  getMedicalTestFiles(medicalTestId):Observable<Response<IMedicalTestFilesDetailsDTO>>{
    let params = new HttpParams()
      .set('ehrTransactionId', medicalTestId)
    return this.http.get<Response<IMedicalTestFilesDetailsDTO>>(this.getMedicalTestFileDetailsUrl, {params: params});
  }

  downloadTestRequestResults(testRequestId, emrDiscriminator): Observable<any> {
    let params = new HttpParams()
      .set('id', testRequestId)
      .set('emrDiscriminator', emrDiscriminator);

    return this.http.get(this.downloadTestRequestResultsUrl, {
      params: params,
    });
  }

  downloadFile(fileUrl): Observable<Blob> {
    return this.http.get(fileUrl, {
      responseType: 'blob',
    });
  }

  uploadResult(testRequestId, testId, resultFile): Observable<any> {
    let formData = new FormData();
    formData.append('RequestId', testRequestId);
    formData.append('TestId', testId);
    formData.append('File', resultFile);

    return this.http.put(this.uploadResultUrl, formData);
  }

  deleteTestResult(requestId, testId, ResultPath): Observable<any> {
    return this.http.put(this.deleteTestResultUrl, {
      requestId,
      testId,
      ResultPath,
    });
  }
}
